<template>
    <div class="device-type-manange relative">
        <el-page-header @back="goBack" content="群聊天记录"></el-page-header>

        <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">聊天内容：</span>
                <el-input v-model="content" placeholder="聊天内容模糊搜索"/>
            </el-col>
            <el-col :md="9" :lg="9" :xl="10">
                <span class="fs-14 pd-r-10">日期：</span>
                <el-date-picker
                        v-model="search_expired_date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-col>
        </el-row>
        <!-- 表单结束 -->

        <div style="clear:both;"></div>
        <div id="layout">
            <div id="docker_user">
                <p>{{ chatroom_name }}群的聊天记录</p>
            </div>
            <div id="chat_box">
                <chatBox v-for="item in chatList" v-bind:chatItem="item" v-bind:key="item.index"></chatBox>
            </div>
        </div>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @prev-click="changePage"
                @next-click="changePage"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>

        <el-dialog title="搜索聊天记录" :visible.sync="dialogFormVisible">
            <div v-for="item in allLogData" style="text-align: left;" @click="onclikLog(item)">
                <span style="font-size: 17px;font-weight: bold;">{{item.user_name}}:</span>
                <span style="margin: 0 0 0 7px;">{{item.value}}</span>
                <el-divider></el-divider>
            </div>

            <el-pagination
                    class="mg-20 ta-r"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[10, 25, 50, 100]"
                    :total="logTotal"
                    :page-size="logPerpage"
                    :current-page="logPage"
                    @prev-click="logChangePage"
                    @next-click="logChangePage"
                    @current-change="logChangePage"
                    @size-change="logChangeSite"
            ></el-pagination>
        </el-dialog>

    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import chatBox from "./chatBox";

    export default {
        data() {
            return {
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                page: 1,
                logPage: 1,
                perpage: 10,
                logPerpage: 10,
                total: 0,
                logTotal: 0,
                tableData: [],
                allRole: [
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    },
                ],
                chatroom_id: '',
                user_id: '',
                content: '',
                obj_id: '',
                start_date: '',
                end_date: '',
                dialogFormVisible: false,
                search_expired_date: '',
                user_name: '',
                chatroom_name: '',
                friend_name: '',
                chatList: [],
                allLogData: [],
            };
        },
        created() {
            this.chatroom_id = this.$route.params.chatroom_id;
            this.chatroom_name = this.$route.params.chatroom_name;
        },
        mounted() {
            // 获取群聊消息列表
            this.getList();
        },
        components: {
            chatBox
        },
        methods: {
            getListLog() {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'groupMessageList',
                    pageinfo: {
                        page: this.logPage,
                        perpage: this.logPerpage,
                    },
                    params: {
                        chatroom_id: this.chatroom_id,
                        content: this.content,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allLogData = [];
                    var allLogData = res.data.data.list;

                    for (var i = 0; i < allLogData.length; i++) {
                        var msg_content = JSON.parse(allLogData[i].msg_content);
                        let obj = {
                            msg_id: allLogData[i].msg_id,
                            user_name: allLogData[i].user_name,
                            value: msg_content.value
                        }
                        this.allLogData.push(obj);
                    }
                    this.dialogFormVisible = true;
                    this.logTotal = res.data.data.page.count;
                    this.logPage = res.data.data.page.page;
                });
            },

            // 点击聊天记录跳转到指定的聊天位置
            onclikLog(data) {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'groupMessageList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        chatroom_id: this.chatroom_id,
                        content: data.content,
                        msg_id: data.msg_id,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    var friend_id = this.obj_id;
                    let res_data = res.data;
                    this.chatList = [];
                    let chatList = res_data.data.list;

                    for (let chat in chatList) {
                        let message = JSON.parse(chatList[chat]['msg_content']);

                        for (let key  in message) {
                            if (key == 'value') {
                                message['value'] = decodeURI(message['value']);

                                switch (message['type']) {
                                    case 'sayText':
                                        // 普通文本
                                        message['value'] = message['value'];
                                        break;
                                    case 'sayImg':
                                        // 发送图片
                                        if (/\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/.test(message['value'])) {
                                            message['value'] = this.imgUrl + decodeURI(message['value']);

                                            let valueArray = [];
                                            valueArray.push(message['value']);
                                            message['valueArray'] = valueArray;
                                        }
                                        break;
                                    case 'sayVoice':
                                        // 发送语音
                                        if (/\.(pcm|wav)$/.test(message['value'])) {
                                            message['value'] = this.imgUrl + decodeURI(message['value']);
                                        }
                                        break;
                                    case 'sayHealthRecords':
                                        // 发送健康档案
                                        message['value'] = JSON.parse(message['value']);
                                        break;
                                    case 'sayOther':
                                        // 邀请
                                        message['value'] = JSON.parse(message['value']);
                                        message['value']['value'] = JSON.parse(message['value']['value']);

                                        break;
                                }

                            }
                        }
                        let item = {
                            index: chat,
                            type: chatList[chat]['type'],
                            create_date: chatList[chat]['create_date'],
                            identity: 1,
                            message: message,
                            user_name: chatList[chat].user_name
                        };
                        this.chatList.push(item);
                    }
                    this.total = res_data.data.page.count;
                    this.page = res_data.data.page.page;

                    this.dialogFormVisible = false;
                });
            },

            getList() {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'groupMessageList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        chatroom_id: this.chatroom_id,
                        content: this.content,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    let res_data = res.data;
                    this.chatList = [];
                    let chatList = res_data.data.list;

                    for (let chat in chatList) {
                        let message = JSON.parse(chatList[chat]['msg_content']);

                        for (let key  in message) {
                            if (key == 'value') {
                                message['value'] = decodeURI(message['value']);

                                switch (message['type']) {
                                    case 'sayText':
                                        // 普通文本
                                        message['value'] = message['value'];
                                        break;
                                    case 'sayImg':
                                        // 发送图片
                                        if (/\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/.test(message['value'])) {
                                            message['value'] = this.imgUrl + decodeURI(message['value']);

                                            let valueArray = [];
                                            valueArray.push(message['value']);
                                            message['valueArray'] = valueArray;
                                        }
                                        break;
                                    case 'sayVoice':
                                        // 发送语音
                                        if (/\.(pcm|wav)$/.test(message['value'])) {
                                            message['value'] = this.imgUrl + decodeURI(message['value']);
                                        }
                                        break;
                                    case 'sayHealthRecords':
                                        // 发送健康档案
                                        message['value'] = JSON.parse(message['value']);
                                        break;
                                    case 'sayOther':
                                        // 邀请
                                        message['value'] = JSON.parse(message['value']);
                                        message['value']['value'] = JSON.parse(message['value']['value']);

                                        break;
                                }

                            }
                        }
                        let item = {
                            index: chat,
                            type: chatList[chat]['type'],
                            create_date: chatList[chat]['create_date'],
                            identity: 1,
                            message: message,
                            user_name: chatList[chat].user_name
                        };
                        this.chatList.push(item);
                    }

                    this.total = res_data.data.page.count;
                    this.page = res_data.data.page.page;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.content = '';
                this.perpage = index;
                this.getList();
            },

            logChangeSite(index) {
                this.logPerpage = index;
                this.getListLog();
            },

            //更换页码
            changePage(index) {
                this.content = '';
                this.page = index;
                this.getList();
            },

            logChangePage(index) {
                this.logPage = index;
                this.getListLog();
            },

            // 重置按钮
            resetForm() {
                this.content = "";
                this.search_expired_date = "";
                this.start_date = "";
                this.end_date = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (!this.content && !this.search_expired_date) {
                    this.page = 1;
                    this.getList();
                    return;
                }

                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }

                if (this.content) {
                    // 有内容搜索
                    this.logPage = 1;
                    this.getListLog();
                } else {
                    // 没有内容直接调用getList
                    this.page = 1;
                    this.getList();
                }
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "systemMessageAdd", params: {
                        user_id: data.user_id,
                        type: 1
                    }
                });
            },

            // 返回上一页
            goBack() {
                window.history.go(-1);
            },
        }
    };
</script>

<style scoped>
    #layout {
        text-align: left;
        margin: 15px 0px;
        border: 1px solid rgba(228, 228, 228, 1);
        display: inline-block;
        width: 98%;
        padding: 1rem;
    }

    #docker_user {
        border-bottom: 1px solid rgba(228, 228, 228, 1);
        background-color: rgba(242, 242, 242, 1);
        padding: 2rem 2rem;
        font-size: 20px;
    }

    #docker_user p {
        margin: 0;
        color: #999999;
    }

    #triangle {
        float: left;
        background-color: #9ea7b5;
        height: 60px;
        width: 30%;
        left: 0;
        color: white;
        font-size: 16px;
        padding-left: 1rem;
    }

    #triangle-right {
        float: left;
        /* display:inline-block; */
        width: 0;
        height: 0;
        border-top: 30px solid transparent;
        border-left: 20px solid #9ea7b5;
        border-bottom: 30px solid transparent;
    }
</style>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
